import React, { useRef } from 'react';
import { Box, Paper } from '@mui/material';
import useRiseIn from '../hooks/useRiseIn';
import LanguageSwitcher from './LanguageSwitcher';
import styles from './auth.module.css';

const AuthCard = ({ children }) => {
  const cardRef = useRef(null);
  useRiseIn(cardRef, { y: 18, duration: 0.55 });

  return (
    <>
      <Paper ref={cardRef} elevation={3} className={styles.card}>
        {children}
      </Paper>
      <Box className={styles.langRow}>
        <LanguageSwitcher alwaysOpen />
      </Box>
    </>
  );
};

export default AuthCard;
